__turbopack_context__.v({
  "active": "matches-module__8iB8qq__active",
  "backBtn": "matches-module__8iB8qq__backBtn",
  "container": "matches-module__8iB8qq__container",
  "detected": "matches-module__8iB8qq__detected",
  "empty": "matches-module__8iB8qq__empty",
  "exactTag": "matches-module__8iB8qq__exactTag",
  "filterBar": "matches-module__8iB8qq__filterBar",
  "filterBtn": "matches-module__8iB8qq__filterBtn",
  "filters": "matches-module__8iB8qq__filters",
  "fuzzyTag": "matches-module__8iB8qq__fuzzyTag",
  "header": "matches-module__8iB8qq__header",
  "loading": "matches-module__8iB8qq__loading",
  "myBrand": "matches-module__8iB8qq__myBrand",
  "primaryBtn": "matches-module__8iB8qq__primaryBtn",
  "progressBar": "matches-module__8iB8qq__progressBar",
  "progressTrack": "matches-module__8iB8qq__progressTrack",
  "scoreRow": "matches-module__8iB8qq__scoreRow",
  "scoreVal": "matches-module__8iB8qq__scoreVal",
  "sliderGroup": "matches-module__8iB8qq__sliderGroup",
  "statCard": "matches-module__8iB8qq__statCard",
  "statLabel": "matches-module__8iB8qq__statLabel",
  "statValue": "matches-module__8iB8qq__statValue",
  "statsRow": "matches-module__8iB8qq__statsRow",
  "table": "matches-module__8iB8qq__table",
  "tableCard": "matches-module__8iB8qq__tableCard",
  "title": "matches-module__8iB8qq__title",
  "titleRow": "matches-module__8iB8qq__titleRow",
});
